export const reactSelectTheme = (theme) => ({
  ...theme,
});
export const reactSelectStyles = {
  control: (base) => ({
    ...base,
    borderRadius: "0.375rem",
    borderColor: "#ced4da",
    "&:hover": {
      borderColor: "#ced4da",
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 2010 }),
  menu: (base) => ({
    ...base,
    minWidth: "fit-content",
    zIndex: 2010,
  }),
  option: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    paddingBlock: "0.1rem",
    paddingInline: "0.5rem",
  }),
};
